module.exports = __webpack_public_path__ + "static/media/hp_candidates.6c88823c.svg";